/**
 * Created by Dale on 13/02/2018.
 * ===============================================
 */
import '../scss/index.scss';
(function () {
    // Specifying what cludo is
    var Cludo = window.Cludo;
    if (typeof window.cludoSettings === 'object') {
        var cludoSettings = {
            customerId: parseInt(window.cludoSettings.customerId, 10),
            engineId: parseInt(window.cludoSettings.engineId, 10),
            searchUrl: window.cludoSettings.searchUrl,
            language: window.cludoSettings.language,
            searchInputs: window.cludoSettings.searchInputs,
            type: window.cludoSettings.type,
            autocompleteMinimumQueryLength: parseInt(window.cludoSettings.autocompleteMinimumQueryLength, 10),
            hideSearchFilters: JSON.parse(window.cludoSettings.hideSearchFilters),
            searchApiUrl: window.cludoSettings.searchApiUrl,
            hideResultsCount: JSON.parse(window.cludoSettings.hideResultsCount),
        };
        // Cludo comes from the API which is enqueued by the CludoSearchController.php
        new Cludo(cludoSettings).init();
    }
})();
